export default {
  CLEAR_QUESTION_SLIDE_DATA: 'clear_question_slide_data',
  CLEAR_PRESENTATION_DATA: 'clear_presentation_data',
  CONNECT_AND_RECONNECT: 'connect',
}
